import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import axios from "axios";
import API_ENDPOINTS from "config/api";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";

export default function ValorInventarioPorAlmacen() {
  const [almacenes, setAlmacenes] = useState([]);
  const empresaId = localStorage.getItem("empresaId");

  useEffect(() => {
    fetchValorPorAlmacen();
  }, [empresaId]);

  const fetchValorPorAlmacen = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.INVENTARIO.VALOR_POR_ALMACEN, {
        params: { empresa_id: empresaId },
      });
      setAlmacenes(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error al obtener valor por almacén:", error);
      setAlmacenes([]);
    }
  };

  const valorTotal = Array.isArray(almacenes)
    ? almacenes.reduce((sum, alm) => sum + parseFloat(alm.valor_total || 0), 0)
    : 0;

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Valor por Almacén
        </MDTypography>
        <Icon fontSize="default" color="success">
          attach_money
        </Icon>
      </MDBox>
      <MDBox pt={3} pb={2} px={2}>
        {almacenes.length > 0 ? (
          almacenes.map((almacen, index) => {
            const porcentaje = valorTotal > 0 ? (almacen.valor_total / valorTotal) * 100 : 0;
            return (
              <MDBox key={almacen.id}>
                <MDBox mb={1}>
                  <MDBox display="flex" justifyContent="space-between" mb={0.5}>
                    <MDTypography variant="button" fontWeight="medium" color="text">
                      {almacen.nombre}
                    </MDTypography>
                    <MDTypography variant="button" color="text">
                      ${parseFloat(almacen.valor_total || 0).toLocaleString()}
                    </MDTypography>
                  </MDBox>
                  <MDProgress
                    value={porcentaje}
                    color={porcentaje > 50 ? "success" : porcentaje > 25 ? "info" : "warning"}
                  />
                </MDBox>
                {index < almacenes.length - 1 && <Divider />}
              </MDBox>
            );
          })
        ) : (
          <MDTypography variant="caption" color="text">
            No hay datos disponibles
          </MDTypography>
        )}
        <Divider />
        <MDBox display="flex" justifyContent="space-between" mt={2}>
          <MDTypography variant="button" fontWeight="bold" color="text">
            Total:
          </MDTypography>
          <MDTypography variant="button" fontWeight="bold" color="success">
            ${valorTotal.toLocaleString()}
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}
